import React from "react";
import numeral from "numeral";
import moment from "moment";

import { withRouter } from "react-router-dom";

import { Modal, Popover, OverlayTrigger } from "react-bootstrap";
import { Button, TileTitle, TileSubtitle, Tile, TileBody, TileItem, Icon } from "aible";
import { LineInput } from "components/Inputs/LineInput";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBullseye,
  faTrash,
  faSyncAlt,
  faCheckCircle,
  faUser,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import uploadDatasetIcon from "images/tileIcons/uploadDataset.svg";
import tableauIcon from "images/tableau.png";
import trayIcon from "images/tray_io_logo.png";

import datasetWhiteIcon from "images/tileIcons/dataset_white.svg";
import refreshWhiteIcon from "images/tileIcons/refresh_white.svg";
import targetWhiteIcon from "images/tileIcons/target_white.svg";

import CheckCircleIcon from "images/EDG/CheckCircleIcon.svg";
import RadioIcon from "images/EDG/RadioIconWhite.svg";
import ExploreIcon from "images/EDG/ExploreIconWhite.svg";
import StarIcon from "images/EDG/StarIcon.svg";
import DateIcon from "images/EDG/DateIcon.svg";
import BookIcon from "images/EDG/BookIcon.svg";
import PinIcon from "images/EDG/PinIcon.svg";
import ChatBubbleIcon from "images/EDG/ChatBubbleIcon.svg";
import UserIcon from "images/EDG/UserIcon.svg";
import CombineIcon from "images/EDG/CombineIcon.svg";
import BlueprintIcon from "images/tileIcons/blueprint_white.svg";

import reportsIcon from "images/tileIcons/barGraphPurple.svg";

import { getDatasetNeedsReindex } from "containers/Upload/reducer";

import styles from "./style.module.css";

class ReportTile extends React.Component {
  handleOnClick(event) {
    const { onHover, onClick } = this.props;
    onHover && onHover(undefined);
    return onClick(event);
  }

  handleDelete(event) {
    event.stopPropagation();
    const { handleDelete, onHover } = this.props;

    if (handleDelete) {
      onHover && onHover(undefined);
      return handleDelete(event);
    } else return;
  }

  // Link handler
  handleOpenLink(url) {
    const { onHover } = this.props;
    onHover && onHover(undefined);
    return window.open(url, "_blank");
  }

  render() {
    const { report, onClick, handleDelete, chartsOrder, history } = this.props;

    const chartCount =
      report && report.metadata && report.metadata.charts_order ? report.metadata.charts_order.length : 0;

    if (!report) {
      return <React.Fragment />;
    }

    // Richard: Add Link Report Check Logic Here
    const isLinkReport = report && report.metadata && report.metadata.linkedData;

    if (isLinkReport) {
      return (
        <div className={styles.tileWrapping}>
          <Tile
            // Click to go to URL
            onClick={() => history.push("/report/" + report.id)}
            handleDelete={handleDelete ? (e) => this.handleDelete(e) : undefined}
            // Tile Button Text
            buttonText={"View Report"}
          >
            <TileTitle
              title={report.name + " (" + report.id + ")"}
              color={"#C8CAD4"}
              icon={"link"}
              style={{ color: "#4B495B" }}
            >
              {report.name}
            </TileTitle>
            <TileBody>
              <TileItem icon={"link"}>
                {(report.metadata.linkedData.dashboardLoc ? report.metadata.linkedData.dashboardLoc.value : "") +
                  " Dashboard"}
              </TileItem>
              <TileItem
                icon={"chart"}
                overlayTitle={
                  (report.metadata.linkedData.yColumns ? report.metadata.linkedData.yColumns.length + " " : "") +
                  "Tracked Variables"
                }
                overlay={
                  <React.Fragment>
                    {(report.metadata.linkedData.yColumns ? report.metadata.linkedData.yColumns : []).map((e, i) => (
                      <div key={i}>{e.value}</div>
                    ))}
                  </React.Fragment>
                }
              >
                {(report.metadata.linkedData.yColumns ? report.metadata.linkedData.yColumns.length + " " : "") +
                  "Variables Tracked"}
              </TileItem>
              {report.created_date ? (
                <TileItem
                  icon={"calendar"}
                  overlay={moment.utc(report.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                >
                  {moment.utc(report.created_date).local().fromNow()}
                </TileItem>
              ) : (
                ""
              )}
              {report.created_by ? (
                <TileItem icon={"user"}>
                  {report.created_by.fullname !== undefined ? report.created_by.fullname : report.created_by}
                </TileItem>
              ) : (
                ""
              )}

              <Button
                onClick={() => {
                  window.open(report.metadata.linkedData.sourceURL);
                }}
                className={styles.linkButton}
                type={"secondary"}
                active
              >
                {"Access Report"}
              </Button>
            </TileBody>
          </Tile>
        </div>
      );
    }

    return (
      <Tile
        onClick={onClick ? (e) => this.handleOnClick(e) : undefined}
        handleDelete={handleDelete ? (e) => this.handleDelete(e) : undefined}
        buttonText={"View Report"}
      >
        <TileTitle
          title={report.label + " (" + report.id + ")"}
          color={"#E6E6FC"}
          icon={"chartPurple"}
          style={{ color: "#7E69D7" }}
        >
          {report.name}
        </TileTitle>
        <TileBody>
          <TileItem icon={"chart"}>{chartCount > 1 || chartCount === 0 ? chartCount + " charts" : "1 chart"}</TileItem>
          {report.created_date ? (
            <TileItem
              icon={"calendar"}
              overlay={moment.utc(report.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
            >
              {moment.utc(report.created_date).local().fromNow()}
            </TileItem>
          ) : (
            ""
          )}
          {report.created_by ? (
            <TileItem icon={"user"}>
              {report.created_by.fullname !== undefined ? report.created_by.fullname : report.created_by}
            </TileItem>
          ) : (
            ""
          )}
        </TileBody>
      </Tile>
    );
  }
}

export default withRouter(ReportTile);
